import { Observable } from 'rxjs';
import { ofType, StateObservable } from 'redux-observable';
import { push } from 'connected-react-router';
import { map, withLatestFrom, filter } from 'rxjs/operators';
import { Actions } from '../../actions';
import { GetArtistsSuccess, SetActiveArtist } from '../action-creators';
import { GET_ARTISTS_SUCCESS } from '../actions';
import AppState from '../../state';
import { getLastActiveArtistId } from '@webapp/utils/artists/last-active';

export const setActiveEpic = (
  action$: Observable<Actions>,
  state$: StateObservable<AppState>
) =>
  action$.pipe(
    ofType<Actions, GetArtistsSuccess>(GET_ARTISTS_SUCCESS),
    withLatestFrom(state$),
    filter(
      ([action, state]) => !!action.artists?.length && !state.artist.active
    ),
    map(([action, state]) => {
      if (state.artist.active) {
        localStorage.removeItem('Trac.PayAsYouGo');
      }

      let artist;

      const lastActiveId = getLastActiveArtistId();

      if (lastActiveId) {
        artist = action.artists.find(
          (a) => a.id === lastActiveId && a.isActive !== false
        );
      }

      if (!artist) {
        artist = action.artists.filter((a) => a.isActive !== false)[0];
      }

      if (!artist?.id) {
        return push('/user/general');
      }

      return new SetActiveArtist(artist);
    })
  );
